import { createRouter, createWebHistory } from 'vue-router';
import TheSpace from '@/components/TheSpace.vue';
import BookingPage from '@/components/BookingPage.vue';
import HomePage from '@/components/HomePage.vue';
import FaqPage from '@/components/FaqPage.vue';
import GalleryPage from '@/components/GalleryPage.vue';

const routes = [
  { path: '/', name: 'Home', component: HomePage },
  { path: '/the-space', name: 'TheSpace', component: TheSpace },
  { path: '/booking', name: 'BookingPage', component: BookingPage },
  { path: '/gallery', name: 'GalleryPage', component: GalleryPage },
  { path: '/faqs', name: 'FaqPage', component: FaqPage }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      // Offset by the section's own scroll-margin-top (set in CSS to clear the fixed nav)
      const el = document.querySelector(to.hash);
      const offset = el ? parseFloat(getComputedStyle(el).scrollMarginTop) || 0 : 0;
      return { el: to.hash, top: offset, behavior: 'smooth' };
    }
    if (savedPosition) {
      return savedPosition;
    }
    return { top: 0 };
  },
});

export default router;
